var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('Nav',{staticClass:"fix",attrs:{"id":"pg"}}),_c('router-view',{staticClass:"marginBot"}),_c('Footer',{staticClass:"bottomfix"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }